export interface EmeaContractModel {
  msContractId?: string;
  msMasterContract?: string;
  contractType?: string;
  migrationStatus?: number;
  solutionSaidNR?: string;
  partnerProId?: string;
  servicePartner?: string;
  customerNameShipLabl?: string;
  ttc?: boolean;
  ttcStartDate?: Date;
  ttcEndDate?: Date;
  comments1?: string;
  comments2?: string;
  comments3?: string;
  comments4?: string;
  partnersList?: any[];
  locked?: boolean;
}

export function emeaContractModelFactory(json?: any): EmeaContractModel {
  json = json || {};

  return {
    msContractId: json.msContractId || "",
    msMasterContract: json.msMasterContract || "",
    contractType: json.contractType || "DMPS",
    migrationStatus: json.migrationStatus || 3,
    solutionSaidNR: json.solutionSaidNR || "",
    partnerProId: json.partnerProId || "",
    servicePartner: json.servicePartner || "",
    customerNameShipLabl: json.customerNameShipLabl || "",
    ttc: json.ttc || false,
    ttcStartDate: json.ttcStartDate,
    ttcEndDate: json.ttcEndDate,
    comments1: json.comments1 || "",
    comments2: json.comments2 || "",
    comments3: json.comments3 || "",
    comments4: json.comments4 || "",
    partnersList: Array.from(json.partnersList || []),
    locked: !json.allowEditing,
  };
}
